import React from "react";
import "../../assets/styels/pages/tickets.scss";
import TicketsContainer from "../../modules/Tickets/templete/TicketsContainer";

const TicketsPage = () => {
  /*  */
  return (
    <>
      <TicketsContainer />
    </>
  );
};

export default TicketsPage;
